import { api } from "@/lib/api";
import type {
  ApiResponse,
  User,
  LoginRequest,
  RegisterRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  AuthTokens,
} from "@learn-me/types";

interface LoginResponse extends AuthTokens {
  user: User;
}

interface RegisterResponse extends AuthTokens {
  user: User;
}

export const authApi = {
  async login(data: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>(
      "/auth/login",
      data,
    );
    return response.data.data!;
  },

  async register(data: RegisterRequest): Promise<RegisterResponse> {
    const response = await api.post<ApiResponse<RegisterResponse>>(
      "/auth/register",
      data,
    );
    return response.data.data!;
  },

  async logout(): Promise<void> {
    await api.post("/auth/logout");
  },

  async getMe(): Promise<User> {
    const response = await api.get<ApiResponse<User>>("/auth/me");
    return response.data.data!;
  },

  async forgotPassword(data: ForgotPasswordRequest): Promise<void> {
    await api.post("/auth/forgot-password", data);
  },

  async resetPassword(data: ResetPasswordRequest): Promise<void> {
    await api.post("/auth/reset-password", data);
  },

  async refreshToken(refreshToken: string): Promise<AuthTokens> {
    const response = await api.post<ApiResponse<AuthTokens>>("/auth/refresh", {
      refreshToken,
    });
    return response.data.data!;
  },
};
